<header class="action-header action-header--with-status">
  <div class="action-header__container action-header__container--column">
    <div class="action-header__container">
      <h1 class="action-header__title">{{ listTitle }}&nbsp;</h1>
      @if (badgeText) {
        <ftr-badge class="action-header__badge" [text]="badgeText"></ftr-badge>
      }
      @if (entities | async; as entitiesRemoteData) {
        <span class="action-header__status">
          @if (entitiesRemoteData.isSuccess()) {
            <ng-container [ngPlural]="entitiesRemoteData.data!.meta.totalItems">
              <ng-template ngPluralCase="=0"></ng-template>
              <ng-template ngPluralCase="=1">1 {{ currentFilter }} {{ singular }}</ng-template>
              <ng-template ngPluralCase="other"
                >{{ entitiesRemoteData.data!.meta.totalItems | number }} {{ currentFilter }} {{ plural }}</ng-template
              >
            </ng-container>
          }
        </span>
      }
    </div>
    @if (subTitle) {
      <p class="action-header__subtitle">
        {{ subTitle }}
      </p>
    }
  </div>
  @if (summary) {
    <p class="action-header__summary">
      {{ summary }}
    </p>
  }
  <div class="action-container">
    <ng-container *ngTemplateOutlet="actionTemplate"></ng-container>
  </div>
</header>
